import { EcommerceAPI } from "../Client";

const appendParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const buildCourierQuery = (payload = {}) => {
  const params = new URLSearchParams();

  appendParam(params, "orderId", payload?.orderId);
  appendParam(params, "orderItemId", payload?.orderItemId);
  appendParam(params, "courierType", payload?.courierType);

  return params.toString();
};

const buildCourierDocumentQuery = (payload = {}) => {
  const params = new URLSearchParams();

  appendParam(params, "orderId", payload?.orderId);
  appendParam(params, "orderItemId", payload?.orderItemId);

  return params.toString();
};

export const getAvailableCouriersApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/couriers/available?${buildCourierQuery(payload)}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createCourierOrderApi = async (payload) => {
  try {
    const params = new URLSearchParams();

    appendParam(params, "orderId", payload?.orderId);
    appendParam(params, "isSinglePackage", payload?.isSinglePackage);
    appendParam(params, "courierType", payload?.courierType);

    const response = await EcommerceAPI.post(
      `/create/courier/order?${params.toString()}`,
      payload?.dto || {},
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const shipNowCourierApi = async (payload) => {
  try {
    const params = new URLSearchParams();

    appendParam(params, "orderItemId", payload?.orderItemId);
    appendParam(params, "orderId", payload?.orderId);
    appendParam(params, "courierCompanyId", payload?.courierCompanyId);
    appendParam(params, "courierType", payload?.courierType);

    const response = await EcommerceAPI.post(
      `/ship/now/courier?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelCourierOrderApi = async (payload) => {
  try {
    const params = new URLSearchParams();

    appendParam(params, "shipOrderId", payload?.shipOrderId);
    appendParam(params, "courierType", payload?.courierType);

    const response = await EcommerceAPI.post(
      `/cancel/courier/order?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateCourierLabelApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/courier/label?${buildCourierDocumentQuery(payload)}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateCourierInvoiceApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/courier/invoice?${buildCourierDocumentQuery(payload)}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
